import React from 'react'
import {ToggleButton, ToggleButtonDefaults} from '../../inputs';

export default function Readonly(props) {
  const { onChange, format } = props

  return (
    <ToggleButton checked={ format } onChange={onChange} label={'Format (Currency?)'} margins={ToggleButtonDefaults.margins}/>
  )
}